import { resolvePathByName, ROUTE_NAMES } from '@/config/routes'
import { globalModalsHistory } from '@/global-modals/globalModalsHistory'
import { useStateRef } from '@roolz/sdk/hooks/helpers/useStateRef'
import { useLastLocation } from '@/hooks/useLastLocation'
import { observer } from 'mobx-react-lite'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

type PropFunc<Props> = (props: Props & {
    onClose: () => void
  }
  // control: {
  //   onClose: () => void
  // }
) => ReactElement | null

export function OverlayModalPage<Props>(PageFunc: PropFunc<Props>) {
  return observer((props: Props): ReactElement | null => {
    // Waiting one tick for global modals been registered
    const [ready, setReady] = useState(false)
    useEffect(() => {
      setReady(true)
    }, [])

    const location = useLocation()
    const { getLastLocation } = useLastLocation()
    const locationRef = useStateRef(location)
    const navigate = useNavigate()

    const fallbackLocation = {
      pathname: resolvePathByName(ROUTE_NAMES.MY_OFFERS),
      search: '',
      hash: '',
      state: {},
      key: ''
    }

    const onClose = useCallback(() => {
      navigate(locationRef.current.state.backgroundLocation)
    }, [location])

    useEffect(() => {
      if(globalModalsHistory['overlay'].at(-2) === location?.pathname) {
        // Probably fix for click < button in browser
        // If new location equels to previous (not current) location, count it as go back

        globalModalsHistory['overlay'].pop()
        return
      }

      if(globalModalsHistory['overlay'].at(-1) !== location?.pathname) {
        globalModalsHistory['overlay'].push(location?.pathname)
      }
    }, [location])

    useEffect(() => {
      if(!location?.state?.backgroundLocation) {
        const lastLocation = getLastLocation()

        navigate(location, {
          state: {
            backgroundLocation: lastLocation
              ? lastLocation?.state?.backgroundLocation ?? lastLocation
              : fallbackLocation
          },
          replace: true
        })
      }
    }, [])

    if(!ready) return null

    return <PageFunc {...props} onClose={onClose}/>
  })
}
